{
  "timestamp": "{0,date} {0,time}",
  "article_reading_time": "bacaan {0} menit",
  "article_actions": "Tindakan",
  "close_entry": "Tutup",
  "info_url_copied": "Alamat URL disalin ke papanklip.",
  "error_share_native": "Tidak dapat membagikan item.",
  "error_share_native_abort": "Tidak dapat membagikan item—kemungkinan disana tidak ada target untuk dibagikan, atau Anda membatalkan hal tersebut.",
  "error_configuration": "Tidak dapat memuat konfigurasi.",
  "error_invalid_subsection": "Subbagian tidak valid:",
  "error_offline_storage_not_available": "Penyimpanan offline tidak tersedia. Pastikan peramban web Anda {0} mendukung DB API yang Terindeks {1} dan, jika Anda menggunakan peramban web Goggle Chrome, pastikan Anda tidak menjalankan selfoss di dalam mode incognito (rahasia).",
  "error_offline_storage": "Kesalahan penyimpanan offline: {0}. Memuat ulang mungkin dapat membantu. Menonaktifkan offline untuk saat ini.",
  "error_sync": "Tidak dapat mengsinkronisasi perubahan terakhir dari server:",
  "error_refreshing_source": "Tidak dapat menyegarkan sumber:",
  "error_saving_color": "Tidak dapat menyimpan warna baru:",
  "error_loading_stats": "Tidak dapat memuat statistik navigasi:",
  "error_loading": "Kesalahan dalam memuat:",
  "error_logout": "Tidak dapat keluar:",
  "error_star_item": "Tidak dapat bintangi/batal bintangi item:",
  "error_mark_item": "Tidak dapat menandai/hapus tanda item:",
  "error_mark_items": "Tidak dapat menandai semua item yang terlihat:",
  "error_unknown_source": "ID sumber tidak diketahui:",
  "error_unknown_tag": "Tag yang tidak diketahui:",
  "error_load_tags": "Tidak dapat memuat tag:",
  "error_delete_source": "Tidak dapat menghapus sumber:",
  "error_edit_source": "Tidak dapat menyimpan perubahan sumber:",
  "error_add_source": "Tidak dapat menambahkan sumber:",
  "error_session_expired": "Sesi kadaluarsa",
  "app_reload": "Muat ulang",
  "app_update": "selfoss telah diperbarui, silahkan muat ulang",
  "sources_refreshed": "Sumber telah disegarkan",
  "reload_list": "Muat ulang daftar",
  "streamerror": "Tidak ada item yang dimuat, muat ulang?",
  "error_unwritable_logs": "Tidak dapat menulis log.",
  "error_check_system_logs": "Sebuah kesalahan terjadi, silahkan periksa log sistem Anda.",
  "error_check_log_file": "Sebuah kesalahan terjadi, silahkan periksa berkas log \"{0}\".",
  "error": "Sebuah kesalahan terjadi",
  "experimental": "Eksperimental",
  "no_title": "Tidak ada judul",
  "login_offline": "Penyimpanan offline",
  "login_invalid_credentials": "Nama pengguna/kata sandi salah",
  "login_password": "Kata sandi",
  "login_username": "Nama pengguna",
  "login": "Masuk",
  "more": "Lebih banyak",
  "no_entries": "Tidak ada entri ditemukan",
  "source_refresh": "Segarkan sumber ini",
  "source_last_post": "Postingan terakhir yang dilihat",
  "source_cancel": "Batal",
  "source_saved": "Disimpan",
  "source_save": "Simpan",
  "source_type": "Jenis",
  "source_select": "Silahkan pilih sumber",
  "source_comma": "Dipisahkan oleh koma",
  "source_pwd_placeholder": "Tidak diubah",
  "source_tags": "Tag",
  "source_autotitle_hint": "Biarkan kosong untuk mengambil judul",
  "source_title": "Judul",
  "source_new": "Sumber baru yang belum disimpan",
  "source_warn": "Yakin ingin menghapus sumber ini?",
  "source_delete": "Hapus",
  "source_filter": "Saring",
  "source_edit": "Sunting",
  "source_export": "Ekspor sumber",
  "source_opml": "atau import sebuah berkas OPML",
  "source_add": "Tambahkan sumber",
  "sources": "Sumber",
  "loginbutton": "Masuk",
  "logoutbutton": "Keluar",
  "settingsbutton": "Pengaturan",
  "refreshbutton": "Segarkan sumber",
  "searchremove": "Sembunyikan pencarian",
  "searchbutton": "Cari",
  "search_label": "Cari istilah",
  "share_copy_label": "Salin tautan ke papanklip",
  "share_mail_label": "Bagikan menggunakan email",
  "share_wordpress_label": "Bagikan di WordPress",
  "share_wallabag_label": "Simpan ke Wallabag",
  "share_pocket_label": "Simpan ke Pocket",
  "share_facebook_label": "Bagikan di Facebook",
  "share_twitter_label": "Bagikan di Twitter",
  "share_diaspora_label": "Bagikan di Diaspora",
  "share_native_label": "Bagikan",
  "load_img": "Tampilkan gambar",
  "open_window": "Buka",
  "next": "Selanjutnya",
  "unmark": "Tandai sebagai belum dibaca",
  "mark": "Tandai sebagai telah dibaca",
  "unstar": "Batal Bintangi",
  "star": "Bintangi",
  "days": "{0,plural,zero {today},satu {yesterday},lainnya {# days ago}}",
  "seconds": "{0,plural,one {1 second},lainnya {# seconds}} lalu",
  "minutes": "{0,plural,one {1 minute},lainnya {# minutes}} lalu",
  "hours": "{0,plural,one {1 hour},lainnya {# hours}} lalu",
  "alltags": "Semua tag",
  "tags": "Tag",
  "offline_navigation_unavailable": "Menukar tag dan sumber saat ini tidak tersedia dalam mode offline.",
  "offline_count": "Item tersedia secara lokal",
  "online_count": "Item tersedia di server",
  "starred": "Dilihat",
  "unread": "Belum Dibaca",
  "newest": "Terbaru",
  "filter": "Saring",
  "markread": "Tandai sebagai telah dibaca",
  "entries_loading": "Memuat entri…",
  "source_deleting": "Menghapus sumber…",
  "source_saving": "Menyimpan perubahan sumber…",
  "sources_leaving_unsaved_prompt": "Tinggalkan setelan dengan perubahan sumber yang belum disimpan?",
  "source_go_to_settings": "Buka pengaturan",
  "source_menu": "Tindakan lainnya",
  "login_in_progress": "Mencoba masuk…",
  "source_browse": "Telusuri",
  "login_error_generic": "Tidak bisa masuk: {errorMessage}",
  "source_params_loading": "Memuat parameter…",
  "share_mastodon_label": "Bagikan di Mastodon",
  "sources_loading": "Memuat sumber…",
  "no_sources": "Tidak ada sumber yang dikonfigurasi.",
  "error_unauthorized": "Silakan {link_begin}masuk{link_end} untuk melanjutkan.",
  "source_warn_cancel_dirty": "Buang perubahan yang belum disimpan?",
  "tag_change_color_button_title": "Ubah warna"
}
